<template>
  <SvgIcon v-if="icon.type === 'svg'" :name="icon.name!" class="credit-card-list-icon" width="24" />
  <i v-else class="icon icon-paypal" alt="PayPal" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import SvgIcon from '@/components/inputs/icon/svg-icon/SvgIcon.vue';
import { IconType } from '@/components/inputs/icon/svg-icon/types';
import { PaymentStateCardBrand } from '@/pages/payment/store/payment-state';

const props = defineProps<{ brand: PaymentStateCardBrand }>();
const cardIconDefault = { type: 'svg', name: 'simple-card-light' };

const iconMap: Record<PaymentStateCardBrand, { type: 'svg' | 'i'; name?: IconType }> = {
  MASTERCARD: { type: 'svg', name: 'mastercard-black' },
  VISA: { type: 'svg', name: 'visa-black' },
  'DINERS CLUB': { type: 'svg', name: 'dinnerclub-light' },
  DISCOVER: { type: 'svg', name: 'discover-light' },
  AMEX: { type: 'svg', name: 'americanexpress-light' },
  MAESTRO: { type: 'svg', name: 'maestro-light' },
  PayPal: { type: 'i' },
};

const icon = computed(() => iconMap[props.brand] ?? cardIconDefault);
</script>

<style scoped lang="scss"></style>
